import styled from 'styled-components';
import variables from '../variables';

const QuizContainer = styled.div`
    width: 100%;
    display: flex;
    background-color: ${(props) => props.bgColor};
    align-content: center;
    justify-content: center;
    position: relative;

    .quiz{
        position: relative;
        width: 95%;
        margin: 5px auto 25px;
    }
    .modal-close-button{
        position: absolute;
        right: 0;
        top: -3px;
        color: #fff;
        
        .close-icon{
            stroke: #fff;
            width: 12px;
            height: 12px;
            
        }
    }
    
    .question-number{
        text-align: center;
        width: 100%;
        color: #fff;
        font-size: 18px;
        border-bottom: 1px rgba(255,255,255, 0.3) solid;
    }

    .quiz-content{
        width: 100%;
        color: #fff;
        img{
            width: 100%;
            height: auto;
        }
    }

    .fieldset{
        border: none;
        margin: 10px 0 0;
        padding: 0;
    }
    .prev{
        position: absolute;
        top: 0;
        left: -15px;
        cursor: pointer;
        .triangle{
            transform: rotate(90deg);
        }
    }
    .answer{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin-bottom: 7.5px;
        margin-left: 0;
    
        .answer-radio{
            display: none;
        }
        .answer-radio:checked + label.answer-label .answer-radio-sub{
            background: white;
        }
        .answer-label{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            width: 100%;
            cursor: pointer;
        }
        .answer-label:hover, .answer-label:active{
            background-color: rgba(255,255,255, 0.3);
        }
        .answer-label:hover .answer-label-text{
            border-bottom: transparent 1px solid;
        }
        .answer-radio-sub{
            margin: 5px 12px 0;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            border: 2px white solid;

            transition: all .1s ease-in-out;
        }
        .answer-label-text{
            width: 100%;
            border-bottom: 1px rgba(255,255,255, 0.3) solid;
            text-align: left;
        }
    }
    
    .form-container {
        margin-top: 0 !important;
    }

    @media screen and (min-width: ${variables.tablet_breakpoint_width}px){
        max-width: 45vw;
    }
    @media screen and (min-width: ${variables.desktop_breakpoint_width}px) and (max-width: ${variables.desktop_max_width}){
        max-width: 40vw;
    }
`;

export default QuizContainer;